import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import GoogleIcon from '../../../icon/GoogleIcon'
import { formatMoney, countUniqueClients } from '../../../helpers/utils'
import { formatLastActivity } from './reportMobileUserCardUtils'

const iconSize = { fontSize: 20 }

export function buildReportRefundsUserMobileCardSections(model) {
  const userName = model.user_name ?? '—'
  const group = model.user_group ?? '—'
  const visited = model.total_visited_clients_count ?? 0
  const attended = model.total_attended_clients_count ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.refund_last_visit)

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Grupo', value: group, valueTitle: group },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const geo = `${model.refund_location_effective_count ?? 0}/${model.refund_location_available_count ?? 0}`

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(countUniqueClients(model.out_route_clients)),
      boldValue: true,
      valueTitle: String(countUniqueClients(model.out_route_clients))
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${model.refund_percent_effective ?? 0}%`,
      boldValue: true,
      valueTitle: `${model.refund_percent_effective ?? 0}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <GoogleIcon name="keyboard_return" size={20} />,
      label: 'Total devoluciones',
      value: formatMoney(model.total_refund),
      boldValue: true,
      valueTitle: formatMoney(model.total_refund)
    }
  ]

  return { summaryRows, detailRows }
}
